var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgressCircle3Of4(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 23,
    viewBox: "0 0 18 17"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "progress-circle-3-of-4_svg__a",
    d: "M9.39 0c2.253.196 4.094 1.02 5.523 2.472C16.343 3.924 17.168 5.767 17.39 8h-3.025c-.109-1.267-.628-2.383-1.56-3.35-.93-.966-2.069-1.51-3.415-1.63V0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-.157)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3A92E5",
    d: "M8.39 17c-2.252-.196-4.093-1.02-5.523-2.472C1.438 13.076.612 11.233.39 9h3.025c.109 1.267.629 2.383 1.56 3.35.93.966 2.07 1.51 3.415 1.63V17z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCC",
    d: "M.39 8c.196-2.253 1.02-4.093 2.472-5.523C4.314 1.047 6.157.222 8.39 0v3.025c-1.266.109-2.383.629-3.35 1.56-.966.93-1.51 2.07-1.63 3.415H.39z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3A92E5",
    d: "M17.39 9c-.196 2.253-1.02 4.093-2.472 5.523-1.452 1.43-3.295 2.255-5.528 2.477v-3.025c1.267-.109 2.383-.629 3.35-1.56.966-.93 1.51-2.07 1.63-3.415h3.02z"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#3A92E5",
    xlinkHref: "#progress-circle-3-of-4_svg__a"
  }))));
}
export default SvgProgressCircle3Of4;